import extendedFormsStyle from './views/extendedFormsStyle';

export default {
    ...extendedFormsStyle,
    footerContainer: {
        display: 'flex',
        padding: 20,
        flex: 1,
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexDirection: 'row-reverse'
    },
    pagesPerRowContainer: {
        minWidth: 91
    },
    pagination: {

    },
    pageInfoSection: {
        color: '#888',
        marginRight: 40,
        marginLeft: 40,
    }
}